module.exports = {
  base: {
    useUrl: "https://gateapi.busanbus.or.kr/", // 운영
    serverVersion: "",
    clientVersion: "",
  },
  urls: {
    login: "api/Account/GetToken", // 로그인
    Apply: "api/Account/Apply", // 약관 동의
    PublicDispatch: {
      PublicDispatch: "PublicDispatch",
      DdlCode: "PublicDispatch/DdlCode",
    },
    Common: {
      GetCode: "COMMON/DdlCode", // 공통코드
      ChangePassword: "ChangePassword/Create", // 비밀번호 변경
      Notice: "Notice", // 공지사항 조회
      NOticeDetail: "Notice/GetDetail", // 공지사항 상세 조회
      SendMessaging: "Fcm/SendMessaging",
    },
    AutoDispatch: {
      AutoDispatch: "AutoDispatch", // 자동배차
      GetMessage: "AutoDispatch/GetMessage", // 메세지 표시
    },
    Holiday: {
      Holiday: "Holiday",
      GetDetail: "Holiday/GetDetail",
      Create: "Holiday/Create",
      Delete: "Holiday/Delete",
    },
    Education: {
      Education: "Education",
      GetEduList: "Education/GetEduList",
      GetDetail: "Education/GetDetail",
      Create: "Education/Create",
      Delete: "Education/Delete",
    },
    AddWork: {
      AddWork: "AddWork",
      GetDetail: "AddWork/GetDetail",
      Create: "AddWork/Create",
      Delete: "AddWork/Delete",
    },
    ChangeCar: {
      ChangeCar: "ChangeCar",
      Create: "ChangeCar/Create",
    },
    AccidentCar: {
      AccidentCar: "AccidentCar",
      GetPlan: "AccidentCar/GetPlan",
      GetDriver: "AccidentCar/GetDriver",
      Create: "AccidentCar/Create",
      Complete: "AccidentCar/Complete",
    },
    EmptyCar: {
      Create: "EmptyCar/Create",
      Cancel: "EmptyCar/Cancel",
    },
    AdminEducation: {
      AdminEducation: "AdminEducation",
      GetEduList: "AdminEducation/GetEduList",
      GetDetail: "AdminEducation/GetDetail",
      Create: "AdminEducation/Create",
      Delete: "AdminEducation/Delete",
    },
    AdminHoliday: {
      AdminHoliday: "AdminHoliday",
      GetHolidayApplyList: "AdminHoliday/GetHolidayList",
      GetDetail: "AdminHoliday/GetDetail",
      Create: "AdminHoliday/Create",
      Delete: "AdminHoliday/Delete",
    },
    AdminAddWork: {
      AdminAddWork: "AdminAddWork",
      GetAddworkApplyList: "AdminAddWork/GetAddworkApplyList",
      GetDetail: "AdminAddWork/GetDetail",
      Create: "AdminAddWork/Create",
      Delete: "AdminAddWork/Delete",
    },
    AdminFacilities: {
      GetServer: "AdminFacilities/GetServer",
      GetReceiver: "AdminFacilities/GetReceiver",
      GetTag: "AdminFacilities/GetTag",
      GetErrorTag: "AdminFacilities/GetErrorTag",
      Create: "AdminFacilities/Create",
    },
    AdminAutoDispatch: {
      AdminAutoDispatch: "AdminAutoDispatch",
      Create: "AdminAutoDispatch/Create",
      Start: "AdminAutoDispatch/Start",
      ChangeIdx: "AdminAutoDispatch/ChangeIdx",
      Execute: "AdminAutoDispatch/Execute",
    },
    AdminRealTimeBus: {
      AdminRealTimeBus: "AdminRealTimeBus",
    },
  },
};
